import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ClientUserRelationship, UserTypeEnum } from '@app/enum/UserTypeEnum';
import { RootStoreState } from '@app/root-store';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { AuthService, CommonService, UserConnectionService } from '@app/shared/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { fromEvent, merge, Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { relationshipStoreActions } from '../../../root-store/index';
import * as loginSelectors from '../../../root-store/login-store/login.selector';
import { MatFormField } from '@angular/material/form-field';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { SharedVaultService } from '@app/shared/services/vault/shared-vault.service';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'connect-relationship-dialog',
  templateUrl: './connect-relationship-dialog.component.html',
  styleUrls: ['./connect-relationship-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConnectRelationshipDialogComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('formField') formField!: MatFormField;
  @ViewChild('formField', { read: ElementRef }) inputElement!: ElementRef;

  @Input('drop-down-long') dropdownClass;
  @Input('data') data;
  @Input('fromInvite') fromInvite;
  @Input('isconnectRelationShip') isconnectRelationShip;
  @Input('hideText') hideText;
  @Input('selectedRelationship') selectedRelationshipData;
  @Output('relationshipId') relationshipId = new EventEmitter<Number>();
  @Output() onDatePicked = new EventEmitter<any>();
  @Input() subMemberPlaceHolder;
  @ViewChild('connectionRelationshipFormDirective', { static: true }) connectionRelationshipFormDirectiveNgForm;
  @Input() isGuardian = false;
  @Input() editName = null;
  @Input() isConnectionModalBtn = false;
  @Input() isConnectionSearch = false;
  @Input() canTruncate = false;
  @Input() relationshipData;
  RelationshipFormNgForm: UntypedFormGroup;
  connectionRelationshipForm: UntypedFormGroup;
  current_user: Record<any, any> | undefined = undefined;
  users: Array<any> = [];
  selectedRelationship: string;
  selectedRelationshipTwo: string;
  selectedRelationshipThree: string;
  isEdit: boolean = false;
  makeAddButtonDisable: boolean = true;
  relationships: any[];
  relationshipsResult: any[];
  isInvite: boolean = false;
  user: any;
  search_type: string;
  AllRelationShip: Array<any> = [];
  filteredOptions: Observable<any[]>;
  noResults: boolean = false;
  showLoader: boolean = false;
  screenWidth: number;
  helpCenterLink: any;
  loginStateObject: any;
  isHomePage: boolean = false;
  resizeObservable$: Observable<Event>;
  subscription: Subscription = new Subscription();
  @Input() setDefaultRelationship: {
    name: string;
    default: boolean;
    id?: string;
  } | null = null;
  @Input() filterList = [];
  @Input() isFromNetworkRequest = false;
  fullName: string = '';
  truncatedName: string = '';
  placeHolder = '';
  personalVaults: any[] | undefined;

  constructor(
    private _fb: UntypedFormBuilder,
    private authService: AuthService,
    private userConnectionService: UserConnectionService,
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    private commonService: CommonService,
    private cd: ChangeDetectorRef,
    private store$: Store<RootStoreState.State>,
    private loginService: LoginStoreEffects,
    private router: Router,
    private store: Store,
    private vaultService$: VaultStoreEffects,
    private sharedVaultsService: SharedVaultService
  ) {
    this.subscription.add(
      this.store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((result) => {
        if (result) {
          this.current_user = result;
        } else {
          this.current_user = null;
        }
      })
    );

    const currentUrl = this.router.url.split('/');
    const ishome = currentUrl[1];
    if (ishome.includes('home')) {
      this.isHomePage = true;
    }

    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        this.loginStateObject = { ...state.data };
        this.helpCenterLink = `https://help.kinnect.us/contacts?name=${this.loginStateObject.first_name}&email=${this.loginStateObject.email}&about=request-to-add-relationship-type`;
      })
    );
    this.fullName = this.current_user.nick_name ?? `${this.current_user.first_name} ${this.current_user.last_name}`;
    this.placeHolder = `How are they related to ${this.current_user.nick_name ?? this.current_user.first_name + ' ' + this.current_user.last_name}?`;

    this.subscription.add(
      this.vaultService$.vaultObject.subscribe((state) => {
        const personal_vault = (state?.vaults || []).filter((v: any) => v.type === 'personal');
        this.personalVaults = personal_vault;
      })
    );
  }
  getClass(dropdownClass) {
    if (!dropdownClass) {
      return 'mobile-mat-autocomplete';
    } else if ((dropdownClass = 'Long')) {
      return 'long-mobile-mat-autocomplete';
    }
  }

  initOnLogin() {
    this.subscription.add(
      this.store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((result) => {
        if (result) {
          this.user = result;
        } else {
          this.user = null;
        }
      })
    );
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    const filterBeginsWithName = [];
    const filterContainsName = [];
    const filterContainsSearchToken = [];

    if (value === undefined || value == null || value?.trim() === '') {
      this.AllRelationShip.forEach((element) => {
        filterContainsSearchToken.push({
          id: element.id,
          name: element.name,
        } as any);
      });
    }

    this.AllRelationShip.forEach((element) => {
      //begins with element name
      if (element.name.toLowerCase().startsWith(filterValue)) {
        filterBeginsWithName.push({
          id: element.id,
          name: element.name,
        });
      }

      //contains element name
      if (element.name.toLowerCase().indexOf(filterValue) !== -1) {
        filterContainsName.push({
          id: element.id,
          name: element.name,
        });
      }

      //contains search token
      if (element.search_tokens.toLowerCase().indexOf(filterValue) !== -1) {
        filterContainsSearchToken.push({
          id: element.id,
          name: element.name,
        });
      }
    });

    const filterResults = [...filterBeginsWithName, ...filterContainsName, ...filterContainsSearchToken];
    const filteredArray = this.arrayUnique(filterResults);

    if (filteredArray.length === 0) {
      this.noResults = true;
    } else {
      this.noResults = false;
    }
    return filteredArray;
  }

  clearData() {
    this.editName = null;
    this.connectionRelationshipForm.get('relationshipType').setValue('');
    this.onDatePicked.emit({ invalid: true });
  }

  arrayUnique(array) {
    const a = array.concat();
    for (let i = 0; i < a.length; ++i) {
      for (let j = i + 1; j < a.length; ++j) {
        if (a[i].id === a[j].id) {
          a.splice(j--, 1);
        }
      }
    }

    return a;
  }

  sort_by_key(array, key) {
    return array.sort(function (a, b) {
      const x = a[key];
      const y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }
  arrayToObservable(arr): Observable<any[]> {
    return new Observable((subscriber) => {
      // Emit each item in the array
      arr.forEach((item) => subscriber.next(item));
      // Complete the observable
      subscriber.complete();
    });
  }
  isFLoating = false;
  async ngOnInit() {
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );
    //get a list of relationships
    this.subscription.add(
      this.store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((result) => {
        if (result) {
          this.current_user = result;
        } else {
          this.current_user = null;
        }
      })
    );

    this.subscription.add(
      this.commonService.getRelationshipJsonFile().subscribe(
        (res) => {
          const unfilteredRelationships = this.sort_by_key(res, 'name');
          this.AllRelationShip = unfilteredRelationships;
          // To satisfy new network setup implementation for professional users, i have commented out the filtering to display only when logged in user is professional
          //   this.current_user?.user_type == UserTypeEnum.Professional
          //     ? unfilteredRelationships.filter((element) => element.is_professional === 'y') || []
          //     : unfilteredRelationships.filter((element) => element.is_professional === 'n') || [];
          if (this.filterList?.length > 0) {
            this.AllRelationShip = this.AllRelationShip.filter((item) => {
              return this.filterList.some((name) => {
                return item.name.toLowerCase() === name.toLowerCase();
              });
            });
          }
          this.AllRelationShip.forEach((element, index) => {
            if (element.name === 'Other' && index !== this.AllRelationShip.length - 1) {
              this.AllRelationShip.splice(index, 1);
              this.AllRelationShip.push(element);
              return;
            }
          });
          this.initFilteredOptions();
          if (this.data && this.data.user) {
            this.RelationshipFormNgForm.controls['relationship_id'].setValue(this.data.user.relationship_id);
            this.RelationshipFormNgForm.controls['relationship_name'].setValue(this.data.user.relationship_name);
            this.connectionRelationshipForm.controls['relationshipType'].setValue(this.data.user.relationship_name);
            if (this.data?.user?.relationship_name === 'Client') {
              this.connectionRelationshipForm.disable();
            }
            this.makeAddButtonDisable = false;
            this.cd.detectChanges();
          }
          if (this.relationshipData) {
            this.RelationshipFormNgForm.controls['relationship_id'].setValue(this.relationshipData.relationship_id);
            this.RelationshipFormNgForm.controls['relationship_name'].setValue(this.relationshipData.relationship_name);
            this.connectionRelationshipForm.controls['relationshipType'].setValue(this.relationshipData.relationship_name);
            if (this.data?.user?.relationship_name === 'Client') {
              this.connectionRelationshipForm.disable();
            }
            this.makeAddButtonDisable = false;
            this.cd.detectChanges();
            if (this.RelationshipFormNgForm.controls['relationship_name']) {
              this.truncatedName = this.fullName;
            }
          }
          // this.RelationshipFormNgForm.controls['relationship_id'].setValue(ClientUserRelationship.id);
          // this.RelationshipFormNgForm.controls['relationship_name'].setValue(ClientUserRelationship.name);
        },
        (error) => {
          console.error('🚀 ~ ConnectRelationshipDialogComponent ~ ngOnInit ~ error:', error);
        }
      )
    );

    this.RelationshipFormNgForm = this._fb.group({
      relationship_id: [''],
      relationship_name: [''],
    });
    this.connectionRelationshipForm = this._fb.group(
      {
        relationshipType: ['Undefined', [], this.CheckRelationShip.bind(this)],
        relationshipTypeTwo: [''],
        relationshipTypeThree: [''],
        relationshipId: Number,
        relationships: [],
        FullName: [''],
        notes: [''],
        requested_user_id: [''],
      },
      {
        validators: [this.relationshipTypeThreeConditionallyRequiredValidator],
      }
    );
    if (this.fullName.length > 8) {
      this.truncatedName = this.fullName.substring(0, 5) + '...';
    } else {
      this.truncatedName = this.fullName;
    }

    if (await this.authService.isAuthenticated()) {
      //only call this if user is already authenticated on a logged in page
      this.initOnLogin();
    }
    this.initFilteredOptions();
    this.connectionRelationshipForm.controls['relationshipType'].setValue('Undefined');
    // Trigger validation for the initial "Undefined" value
    this.connectionRelationshipForm.controls['relationshipType'].updateValueAndValidity();

    this.subscription.add(
      this.connectionRelationshipForm.statusChanges.subscribe((valid) => {
        if (valid === 'VALID') {
          this.relationshipId.emit(
            this.connectionRelationshipForm.value.relationshipTypeThree ||
              this.connectionRelationshipForm.value.relationshipTypeTwo ||
              this.connectionRelationshipForm.value.relationshipType
          );
        } else {
          this.relationshipId.emit(0);
        }
      })
    );

    if (this.data && !this.data.user) {
      return;
    }

    this.relationships = [];
    if (this.data) {
      this.isInvite = this.data.user.user_id === undefined;
    }
    //get a tree of selected relationships
    // let relationship_id = '';
    // if (this.data && this.data.user.connection_id) {
    //   relationship_id = this.data.user.connection_relationship_id;
    //   // this.commonService.getRelationahipsResult(relationship_id).subscribe((results) => {
    //   //   this.relationshipsResult = results.data;
    //   // });
    // }

    if (this.data && this.data.user && this.data.user.relationship_id) {
      this.isEdit = true;
    }
    if (this.data && this.data.user) {
      this.connectionRelationshipForm.controls.FullName.setValue(this.data.user.user_first_middle_name ? this.data.user.user_first_middle_name : '');

      this.connectionRelationshipForm.controls.requested_user_id.setValue(this.data.user.user_id);

      this.RelationshipFormNgForm.controls['relationship_id'].setValue(this.data.user.relationship_id);
      this.RelationshipFormNgForm.controls['relationship_name'].setValue(this.data.user.relationship_name);
      this.connectionRelationshipForm.controls['relationshipType'].setValue(this.data?.user?.relationship_name);
      this.makeAddButtonDisable = false;
      this.cd.detectChanges();
    }
    this.search_type = 'connected';
    this.allConnection();
    this.isconnectRelationShip = true;
    this.connectionRelationshipForm.controls.relationshipType.setValue('');
  }
  initFilteredOptions() {
    if (this.AllRelationShip.length < 0) {
      this.filteredOptions = undefined;
      this.cd.detectChanges();
    } else {
      this.filteredOptions = this.connectionRelationshipForm.get('relationshipType').valueChanges.pipe(
        startWith(''),
        map((value) => this._filter(value ?? ''))
      );
    }
    this.cd.detectChanges();
  }
  CheckRelationShip(control: UntypedFormControl) {
    const q = new Promise((resolve) => {
      const data = control.value;

      // Handle "Undefined" as a valid default value
      if (data === 'Undefined') {
        this.RelationshipFormNgForm.controls['relationship_id'].setValue('118');
        this.RelationshipFormNgForm.controls['relationship_name'].setValue('Undefined');
        this.onDatePicked.emit({ name: 'Undefined', id: '118', invalid: false });
        this.makeAddButtonDisable = false;
        resolve(null);
      } else if (data && this.AllRelationShip.findIndex((x) => x.name.toLowerCase() === data.toLowerCase()) !== -1) {
        const Senddata = this.AllRelationShip.find((x) => x.name.toLowerCase() === data.toLowerCase());
        Senddata['invalid'] = false;
        this.RelationshipFormNgForm.controls['relationship_id'].setValue(Senddata['id']);
        this.RelationshipFormNgForm.controls['relationship_name'].setValue(Senddata['name']);
        this.onDatePicked.emit(Senddata);
        this.makeAddButtonDisable = false;
        resolve(null);
      } else {
        this.RelationshipFormNgForm.controls['relationship_id'].reset('');
        this.RelationshipFormNgForm.controls['relationship_name'].reset('');
        this.onDatePicked.emit({ invalid: true });
        this.makeAddButtonDisable = true;
        resolve({ invalid: true });
      }
    });
    return q;
  }
  setDefautlRelationShip() {
    this.selectedRelationship = '3';
    this.connectionRelationshipForm.controls.relationshipType.setValue(this.selectedRelationship);
    this.changeRelationship('relationshipType');
    this.selectedRelationshipTwo = '72';
    this.connectionRelationshipForm.controls.relationshipTypeTwo.setValue(this.selectedRelationshipTwo);
    this.changeRelationship('relationshipTypeTwo');
    this.cd.detectChanges();
  }
  allConnection() {
    // this.userConnectionService.getConnections('user', { search_type: this.search_type }).subscribe(
    //   async (data: any) => {
    //     this.cd.markForCheck();
    //     this.users = [...data];
    //   },
    //   (error: any) => {
    //     this.toastr.error(error.error.message);
    //   }
    // );
  }

  onNoClick(): void {
    this.activeModal.close('no');
    this.subscription.add(this.userConnectionService.getConnections('user').subscribe());
  }

  doRelationshipConnect(params) {
    const finaldata = {
      relationship_name: this.RelationshipFormNgForm.controls['relationship_name'].value
        ? this.RelationshipFormNgForm.controls['relationship_name'].value
        : '',
      to_user_id: params.user.user_id,
      user_id: this.user.id,
      requested_user_id: this.connectionRelationshipForm.controls['requested_user_id'].value
        ? this.connectionRelationshipForm.controls['requested_user_id'].value
        : '',
      relationship_id: this.RelationshipFormNgForm.controls['relationship_id'].value
        ? this.RelationshipFormNgForm.controls['relationship_id'].value
        : '',
      notes: this.connectionRelationshipForm.controls['notes'].value,
    };
    delete finaldata['notes'];
    if (!this.connectionRelationshipForm.controls['relationshipType']?.value?.length) {
      return;
    }
    if (params?.user.user_type === UserTypeEnum.Professional && this.current_user['user_type'] !== UserTypeEnum.Professional) {
      finaldata['relationship_id'] = ClientUserRelationship.id;
      finaldata['relationship_name'] = ClientUserRelationship.name;
    }
    this.subscription.add(
      this.userConnectionService.connectToUser(finaldata).subscribe(
        () => {
          this.store$.dispatch(new relationshipStoreActions.AllRelationships());
          if (!this.isInvite) {
            const data = {
              isexistingUser: true,
              success: true,
              relationship_name: this.RelationshipFormNgForm.controls['relationship_name'].value
                ? this.RelationshipFormNgForm.controls['relationship_name'].value
                : '',
              FullName: this.data.user.user_first_middle_name + ' ' + this.data.user.user_last_name,
              requested_user_id: this.connectionRelationshipForm.controls['requested_user_id'].value
                ? this.connectionRelationshipForm.controls['requested_user_id'].value
                : '',
              relationship_id: this.RelationshipFormNgForm.controls['relationship_id'].value
                ? this.RelationshipFormNgForm.controls['relationship_id'].value
                : '',
            };

            this.subscription.add(this.userConnectionService.sendRelationshipRequestNotification(finaldata).subscribe());
            this.activeModal.close(data);
          } else {
            this.activeModal.close(finaldata);
          }
        },
        (error) => {
          console.error('🚀 ~ ConnectRelationshipDialogComponent ~ doRelationshipConnect ~ error:', error);
        }
      )
    );
  }

  doRelationshipUpdate(params) {
    if (this.connectionRelationshipForm.invalid) {
      return;
    }
    this.connectionRelationshipForm.value.connect_id = params.connection_id;
    this.connectionRelationshipForm.value.connect_status = params.connection_status;

    if (this.connectionRelationshipForm.value.immediateFamilyType !== 'sibling') {
      this.connectionRelationshipForm.value.siblingType = '';
    }

    const finaldata = {
      to_user_id: this.data.user.to_user_id,
      from_user_id: this.data.user.from_user_id,
      status: this.data.user.connection_status ?? 'approved',
      relationship_name: this.RelationshipFormNgForm.controls['relationship_name'].value
        ? this.RelationshipFormNgForm.controls['relationship_name'].value
        : '',
      relationship_id: this.RelationshipFormNgForm.controls['relationship_id'].value
        ? this.RelationshipFormNgForm.controls['relationship_id'].value
        : '',
    };

    this.showLoader = true;
    this.cd.detectChanges();
    this.subscription.add(
      this.userConnectionService.userConnectionUpdate(finaldata).subscribe(
        (data: any) => {
          const spouseList = ['Husband', 'Wife', 'Spouse', 'Fiancee', 'Civil Partner', 'Domestic Partner'];
          const isSpouse = finaldata.relationship_name && spouseList.includes(finaldata.relationship_name);
          if (isSpouse) {
            this.createSharedVault();
          }

          this.showLoader = false;
          this.activeModal.close(data);
          this.connectionRelationshipForm.value.relationshipId =
            this.connectionRelationshipForm.value.relationshipTypeThree ||
            this.connectionRelationshipForm.value.relationshipTypeTwo ||
            this.connectionRelationshipForm.value.relationshipType;
          this.toastr.success(`Relationship with ${params.user_first_middle_name} ${params.user_last_name} updated`);
          this.store$.dispatch(new relationshipStoreActions.AllRelationships());
          this.subscription.add(this.userConnectionService.sendRelationshipUpdateNotification(finaldata).subscribe());
        },
        (error: any) => {
          this.showLoader = false;
          this.toastr.error(error.error.message);
        }
      )
    );
  }

  getRelationshipName(relationship_id) {
    return this.relationships.filter((r) => r.id === relationship_id)[0].name;
  }
  changeRelationship(selectedValue) {
    //clear all controls
    ['relationshipTypeTwo', 'relationshipTypeThree'].forEach((typeVar) => {
      if (typeVar === selectedValue) {
        return;
      }

      this.connectionRelationshipForm.get(typeVar).setValue(undefined);
      this.connectionRelationshipForm.get(typeVar).updateValueAndValidity();
    });

    if (!selectedValue) {
      this.selectedRelationshipTwo = this.selectedRelationshipTwo ? this.selectedRelationshipTwo : null;
      this.selectedRelationshipThree = this.selectedRelationshipThree ? this.selectedRelationshipThree : null;
    }
    this.cd.detectChanges();
  }

  relationshipTypeThreeConditionallyRequiredValidator(formGroup: UntypedFormGroup) {
    if (!formGroup.get('relationships').value) {
      return null;
    }

    if (formGroup.get('relationships').value.filter((r) => r.parent_id === formGroup.get('relationshipTypeTwo').value).length > 0) {
      return Validators.required(formGroup.get('relationshipTypeThree'))
        ? {
            required: true,
          }
        : null;
    }

    return null;
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
    this.editName = null;
  }
  labelClassLists = '';
  isLabelFloating = false;
  ngAfterViewInit(): void {
    if (this.setDefaultRelationship) {
      this.connectionRelationshipForm.controls['relationshipType'].setValue(this.setDefaultRelationship.name);
    }
    this.labelClassLists = this.formField._floatingLabel.element.classList.value;
    this.isLabelFloating = this.formField._shouldLabelFloat();
    // try {
    const input = this.inputElement.nativeElement.querySelector('input');
    // Combine valueChanges and focus/blur events
    const valueChanges$ = fromEvent(input, 'input');
    const focusChanges$ = fromEvent(input, 'focus');
    const blurChanges$ = fromEvent(input, 'blur');
    const keydownChanges$ = fromEvent(input, 'keydown');
    const clickChanges$ = fromEvent(input, 'click');

    // Merge the observables
    const combined$ = merge(valueChanges$, focusChanges$, blurChanges$, clickChanges$, keydownChanges$);

    // Subscribe to combined observable
    // eslint-disable-next-line eslint-rules/no-unmanaged-subscriptions
    this.subscription = combined$.subscribe(() => {
      this.labelClassLists = this.formField._floatingLabel.element.classList.value;
      this.isLabelFloating = this.formField._shouldLabelFloat();
    });
    // } catch (error) {}
  }
  setEditName(e) {
    const relationship = this.AllRelationShip.find((r) => e === r.name);
    this.onDatePicked.emit(relationship);
  }
  handleTabFix(event: any) {
    if (event.key === 'Tab' || event.code === 'Tab') {
      event.preventDefault();
      event.stopPropagation();
    }
  }
  navigateToHelp(event, helpCenterLink) {
    event.preventDefault();
    event.stopPropagation();
    window.open(helpCenterLink, '_blank');
  }

  createSharedVault() {
    const userId = this.data?.user?.user_id;
    const userName = this.data?.user?.user_first_middle_name || this.data?.user?.user_first_name || 'User';

    const members = {
      name: this.data.user?.user_nickname ?? userName,
      user_id: userId as any,
      type: 'member' as 'member',
    };
    const allVaultNames = this.personalVaults.map((v) => v.name);

    const vaultMembers = [
      {
        user_first_name: this.user?.first_name || this.user?.first_middle_name,
        user_id: this.user?.id ?? this.user?.user_id,
        type: 'owner',
      },
      {
        user_first_name: userName,
        user_id: this.data?.user?.user_id,
      },
    ];
    const baseName = this.formatVaultName(vaultMembers);
    const vaultName = this.generateUniqueVaultName(baseName, allVaultNames);

    const sharedPayload = {
      user_id: this.user?.id as any,
      name: vaultName,
      member: [members],
    };

    const payload = {
      name: vaultName ?? 'Untitled Vault',
      type: 'personal',
      user_id: this.user?.id ?? this.user?.user_id,
      member: vaultMembers,
      url: '/vault',
    };

    const matching = allVaultNames.filter((name) => name === baseName || name.startsWith(baseName + ' '));
    if (matching.length === 0) {
      this.subscription.add(
        this.sharedVaultsService.createVault(payload).subscribe(
          async (data) => {
            if (data) {
              this.subscription.add(
                this.sharedVaultsService.createSharedVault(sharedPayload).subscribe(
                  () => {
                    // Shared vault created successfully
                  },
                  (err) => {
                    console.error('Error creating shared vault:', err);
                  }
                )
              );
            }
          },
          (error: any) => {}
        )
      );
    }
  }
  formatVaultName(users) {
    const names = users.map((user) => user?.user_first_name || user?.first_name);
    if (names.length === 0) return '';
    if (names.length === 1) return names[0];
    if (names.length === 2) return names.join(' & ');

    // For more than 2 names, join with a comma, except for the last one
    return `${names.slice(0, -1).join(', ')}, & ${names[names.length - 1]}`;
  }
  generateUniqueVaultName(baseName: string, existingVaultNames: string[]): string {
    // get names that start with the same base name
    const matching = existingVaultNames.filter((name) => name === baseName || name.startsWith(baseName + ' '));
    if (matching.length === 0) {
      return baseName;
    }
    // extract numeric suffixes
    const counts = matching.map((name) => {
      const parts = name.replace(baseName, '').trim(); // get suffix e.g. "2"
      const num = parseInt(parts);
      return isNaN(num) ? 1 : num;
    });

    const max = Math.max(...counts);
    return `${baseName} ${max + 1}`;
  }
}
